module.exports = __webpack_public_path__ + "static/media/izlozba (10).ee246fbd.jpg";